import React, { useState, useEffect } from 'react';
import { Skeleton } from '../components/ui/skeleton';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TermsOfService = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/admin/localization/public/legal/terms_of_service`);
        if (response.data.success) {
          setPage(response.data.page);
        }
      } catch (err) {
        console.error('Error fetching terms of service:', err);
        setError('Unable to load terms of service');
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white py-8">
        <div className="max-w-4xl mx-auto px-4">
          <Skeleton className="h-12 w-64 mb-6" />
          <div className="space-y-4">
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-6 w-5/6" />
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-6 w-2/3" />
          </div>
        </div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen bg-white py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center py-12">
            <p className="text-gray-500">{error || 'Terms of service not available'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">{page.title}</h1>
          {page.last_updated && (
            <p className="text-sm text-gray-500 mt-2">Last updated: {page.last_updated}</p>
          )}
        </div>
        
        <article className="terms-content text-gray-700 leading-relaxed">
          <ReactMarkdown
            components={{
              h1: ({children}) => <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">{children}</h2>,
              h2: ({children}) => <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4">{children}</h3>,
              h3: ({children}) => <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">{children}</h4>,
              p: ({children}) => <p className="mb-4 leading-relaxed">{children}</p>,
              ul: ({children}) => <ul className="list-disc list-inside mb-4 space-y-2 ml-4">{children}</ul>,
              ol: ({children}) => <ol className="list-decimal list-inside mb-4 space-y-2 ml-4">{children}</ol>,
              li: ({children}) => <li className="mb-1">{children}</li>,
              strong: ({children}) => <strong className="font-semibold text-gray-900">{children}</strong>,
              hr: () => <hr className="my-8 border-gray-200" />,
              a: ({href, children}) => <a href={href} className="text-blue-600 hover:underline">{children}</a>,
            }}
          >
            {page.content}
          </ReactMarkdown>
        </article>
      </div>
    </div>
  );
};

export default TermsOfService;
